import { call, put, takeEvery } from 'redux-saga/effects';
import { bigCommerceActionCreators, BigCommerceApiKeys, IBigCommerceStore, UpdateBigCommerceStore } from '..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../bigCommerceApi';

function* updateBigCommerceStore(action: UpdateBigCommerceStore) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<IEntityWithMessages<IBigCommerceStore>> = yield call(
    api.updateBigCommerceStore,
    action.payload
  );

  if (!response.requestFailed && response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(bigCommerceActionCreators.setStores([response.value.value]));
    }
  } else {
    // TODO - show error message
    yield showFailedRequestDialog(response);
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateBigCommerceStore() {
  yield takeEvery(BigCommerceApiKeys.UPDATE_BIG_COMMERCE_STORE, updateBigCommerceStore);
}
